import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';

import StrawberryRollet from '../../../../images/rollet_strawberry.jpg';
import DanmarkiSide from '../../../../images/danmarki_whole_side_tray.jpg';
import CreamPuffs from '../../../../images/cream_puffs.jpg';
import NescafeRollet from '../../../../images/whole_nescafe_rollet.jpg';
import MixSheriniKeshmeshi from '../../../../images/mix_keshmeshi.jpg';
import MixSheriniPapyouni from '../../../../images/mix_sherini_1.jpg';
import BananaWalnut from '../../../../images/banana_walnut_cake.jpg';
import Owners from '../../../../images/shaniz_owners.jpg';
import MochaRollet from '../../../../images/mocha_rollet.jpg';

const ImageBackdrop = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: '#000',
  opacity: 0.5,
  transition: theme.transitions.create('opacity'),
}));

const ImageIconButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  padding: 0,
  borderRadius: 0,
  height: '40vh',
  [theme.breakpoints.down('md')]: {
    width: '100% !important',
    height: 100,
  },
  '&:hover': {
    zIndex: 1,
  },
  '&:hover .imageBackdrop': {
    opacity: 0.15,
  },
  '&:hover .imageMarked': {
    opacity: 0,
  },
  '& .imageMarked': {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
}));

const images = [
  {
    url: StrawberryRollet,
    width: '40%',
  },
  {
    url: MochaRollet,
    width: '20%',
  },
  {
    url: CreamPuffs,
    width: '40%',
  },
  {
    url: DanmarkiSide,
    width: '38%',
  },
  {
    url: NescafeRollet,
    width: '38%',
  },
  {
    url: MixSheriniKeshmeshi,
    width: '24%',
  },
  {
    url: MixSheriniPapyouni,
    width: '40%',
  },
  {
    url: BananaWalnut,
    width: '20%',
  },
  {
    url: Owners,
    width: '40%',
  },
];

export default function ProductCategories() {
  return (
    <Container component="section" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" marked="center" align="center" component="h2">
        For all tastes and all desires
      </Typography>
      <Box sx={{ mt: 8, display: 'flex', flexWrap: 'wrap' }}>
        {images.map((image) => (
          <ImageIconButton
            key={image}
            style={{
              width: image.width,
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundSize: 'cover',
                backgroundPosition: 'center 40%',
                backgroundImage: `url(${image.url})`,
              }}
            />
            <ImageBackdrop className="imageBackdrop" />
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'common.white',
              }}
            >
              <Typography
                component="h3"
                variant="h6"
                color="inherit"
                className="imageTitle"
              >
              </Typography>
            </Box>
          </ImageIconButton>
        ))}
      </Box>
    </Container>
  );
}
